import { getHeaders } from '../helpers';
import { getChestApiUrl } from '../../helpers/index';

const get = ({
	session,
	hotelId = null,
	order = "price",
	page = 0,
	filter = "all",
	type = 'all',
	size = 12,
	filters = {}
}) => {
	try {
		if (session) {
			// Prevent undefined in values
			filters = { ...{ popular: [""], stars: [""], budget: [""], score: [""], type: "all" }, ...filters };

			// Clean from spaces in array
			filters.popular = filters.popular.length > 1 ? filters.popular.filter(el => el !== "") : filters.popular;
			filters.stars = filters.stars.length > 1 ? filters.stars.filter(el => el !== "") : filters.stars;
			filters.budget = filters.budget.length > 1 ? filters.budget.filter(el => el !== "") : filters.budget;
			filters.score = filters.score.length > 1 ? filters.score.filter(el => el !== "") : filters.score;

			let resultNum = 0;

			if (page !== 0) {
				resultNum = page * size;
			}

			const params = `s=${session}&st=${order}&from=${resultNum}&qt=${filters.type}&popular=${filters.popular.join(',')}&stars=${filters.stars.join(',')}&budget=${filters.budget.join(',')}&score=${filters.score.join(',')}${hotelId ? `&hotelId=${hotelId}` : ''}`;
			const url = `${getChestApiUrl()}/chestApi/hotels/results?${params}`;

			return fetch(url).then(r => r.json()).catch(err => console.log("[ERROR]:", err));

		} else {
			throw new Error(' NO SESSION AVALIABLE ');
		}
	} catch (err) {
		throw err;
	}
}



const update = ({ session }) => {
	try {
		return fetch(`${getChestApiUrl()}/chestApi/f/results/update`, {
			method: 'POST',
			headers: getHeaders(),
			body: JSON.stringify({ session })
		})
			.then(r => r.json())
			.then(res => !res.error);
	} catch (err) {
		throw err;
	}
}

export default {
	get,
	update
}
